import { useQuery } from "@tanstack/react-query";

import type { paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGet, qk } from "@/shared/api";

export type AdminAccount = Result<paths["/api/v1/admin/admins"]["get"]>[number];

export function useAdmins(enabled = true) {
  return useQuery({
    queryKey: qk.admins(),
    enabled,
    queryFn: ({ signal }) => apiGet("/api/v1/admin/admins", { signal }),
  });
}
